import { IConsentFormattedValue, IConsentsValuesObject } from "../models/consent.model";

export function getConsentsFormattedValues(
    consents: IConsentsValuesObject,
    email: string,
    contextId: number | undefined,
): IConsentFormattedValue[] {
    return Object.keys(consents).map(key => {
        return {
            ...consents[key],
            email,
            contextId,
        }
    })
}